<template>
  <v-container fluid>
    <v-row>
      <main-header-plat-a />
      <main-header-plat-b :navBItems="schema.navBItems" />
      <v-overlay-loader class="mt-10" />
    </v-row>
    <v-card flat class="d-flex justify-center text-subtitle-1 primary--text font-weight-medium mt-9"
      >APLICADAS</v-card
    >
    <v-form-base
      class="d-flex justify-star mt-4 ml-1"
      v-if="
        Object.keys(schema.statsFormDate || {}).length &&
        Object.keys(data.modelStatsDate || {}).length
      "
      :schema="schema.statsFormDate"
      :model="data.modelStatsDate"
      @click="clickOutside"
    />
    <span class="black--text caption ml-3"
      >Se contabiliza los Correctores cuya sección de Filiación se ha completado.</span
    >

    <v-card
      flat
      class="d-flex justify-star text-subtitle-1 primary--text font-weight-bold mt-4 ml-3"
      >DIARIO</v-card
    >
    <v-card class="mt-3 mx-3" v-if="data && data.lineDaily && data.lineDaily.length">
      <apexchart
        id="chart"
        class="d-flex justify-space-around py-3 mb-10"
        type="line"
        height="310"
        width="85%"
        :options="computedOptionsDaily"
        :series="data.lineDaily"
      ></apexchart>
    </v-card>

    <v-card
      flat
      class="d-flex justify-star text-subtitle-1 primary--text font-weight-bold mt-4 ml-3"
      >MENSUAL</v-card
    >

    <v-card class="mt-5 mx-3" v-if="data && data.lineMonth && data.lineMonth.length">
      <apexchart
        id="chart1"
        class="d-flex justify-space-around py-3 mb-12"
        type="line"
        height="380"
        width="85%"
        :options="chartOptionsLineMonth"
        :series="data.lineMonth"
      ></apexchart>
    </v-card>

    <v-card class="mt-5 mx-3" v-if="data && data.barMonth && data.barMonth.length">
      <v-card-title class="d-flex justify-center text-subtitle-1 black--text font-weight-medium"
        >CORRECTORES</v-card-title
      >
      <apexchart
        id="chart2"
        class="d-flex justify-space-around mb-14"
        type="bar"
        height="380"
        width="85%"
        :options="chartOptionsBarMonth"
        :series="data.barMonth"
      ></apexchart>
    </v-card>

    <v-card
      flat
      class="d-flex justify-star text-subtitle-1 primary--text font-weight-bold mt-4 ml-3"
      >ANUAL</v-card
    >

    <v-card class="mt-5 mx-3" v-if="data && data.lineYear && data.lineYear.length">
      <apexchart
        id="chart3"
        class="d-flex justify-space-around py-3 mb-12"
        type="line"
        height="380"
        width="85%"
        :options="chartOptionsLineYear"
        :series="data.lineYear"
      ></apexchart>
    </v-card>

    <v-card class="mt-5 mx-3" v-if="data && data.barYear && data.barYear.length">
      <v-card-title class="d-flex justify-center text-subtitle-1 black--text font-weight-medium"
        >CORRECTORES</v-card-title
      >
      <apexchart
        id="chart4"
        class="d-flex justify-space-around mb-16"
        type="bar"
        height="380"
        width="85%"
        :options="chartOptionsBarYear"
        :series="data.barYear"
      ></apexchart>
    </v-card>

    <v-card class="mt-5 mx-3">
      <v-card-title
        class="d-flex justify-center text-subtitle-1 black--text font-weight-medium mb-3"
        >ETAPAS DE EVOLUTIVAS</v-card-title
      >
      <v-card>
        <v-table-exten-statistics-b
          width="90%"
          :headPart="data.headPartCo"
          :statPart="data.statPartCo"
        />
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VTableExtenStatisticsB from '@/components/base/VTableExtenStatisticsB.vue';
import VFormBase from 'vuetify-form-base';

export default {
  name: 'ProStatisticsBPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VTableExtenStatisticsB,
    VFormBase,
  },
  data() {
    return {
      chartOptionsLineDaily: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 5, 5, 5],
          curve: 'straight',
          dashArray: [0, 8, 5, 5],
        },
        title: {
          text: '',
          align: 'left',
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
      chartOptionsLineMonth: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 5, 5, 5],
          curve: 'straight',
          dashArray: [0, 8, 5, 5],
        },
        title: {
          text: '',
          align: 'left',
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Oct',
            'Nov',
            'Dic',
          ],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
      chartOptionsLineYear: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 5, 5, 5],
          curve: 'straight',
          dashArray: [0, 8, 5, 5],
        },
        title: {
          text: '',
          align: 'left',
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [
            '2021',
            '2022',
            '2023',
            '2024',
            '2025',
            '2026',
            '2027',
            '2028',
            '2029',
            '2030',
          ],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          borderColor: '#f1f1f1',
        },
      },
      chartOptionsBarMonth: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        title: {
          text: '',
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
          categories: [
            'CO-01',
            'CO-02',
            'CO-03',
            'CO-04',
            'CO-05',
            'CO-15',
            'CO-16',
            'CO-17',
            'CO-18',
            'CO-20',
            'CO-35',
            'CO-39',
            'CO-41',
            'CO-43',
            'CO-44',
            'CO-45',
            'CO-46',
            'CO-51',
            'CO-52',
            'CO-55',
          ],
        },
      },
      chartOptionsBarYear: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        title: {
          text: '',
        },
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
          categories: [
            'CO-01',
            'CO-02',
            'CO-03',
            'CO-04',
            'CO-05',
            'CO-15',
            'CO-16',
            'CO-17',
            'CO-18',
            'CO-20',
            'CO-35',
            'CO-39',
            'CO-41',
            'CO-43',
            'CO-44',
            'CO-45',
            'CO-46',
            'CO-51',
            'CO-52',
            'CO-55',
          ],
        },
      },
    };
  },
  mounted() {
    this.loadSchema();
    this.loadData();
  },
  computed: {
    ...mapGetters('proStatisticsB', ['schema', 'data', 'status']),

    computedOptionsDaily() {
      return {
        ...this.chartOptionsLineDaily,
        xaxis: {
          ...this.chartOptionsLineDaily.xaxis,
          categories: (this.data && this.data.dailyXaxisCat) ? this.data.dailyXaxisCat : []
        }
      };
    }
  },
  methods: {
    ...mapActions('proStatisticsB', ['loadSchema', 'loadData']),

    clickOutside() {
      this.selectLoad();
    },
    async selectLoad() {
      let modelForm = {};
      modelForm.modelStatsDate = this.data.modelStatsDate;

      this.$store.dispatch('proStatisticsB/loadData', { modelForm })
    },
  },
};
</script>
